<template>
  <b-form-group
    label="Makbuz No"
    label-for="receipt_no"
  >
    <validation-provider
      #default="{ errors }"
      name="Makbuz No"
      rules="required"
    >
      <b-form-input
        id="receipt_no"
        v-model="dataItem.receipt_no"
        placeholder="Makbuz No"
      />
      <small class="text-danger">{{ errors[0] }}</small>
    </validation-provider>
  </b-form-group>
</template>

<script>
import { ValidationProvider, localize } from 'vee-validate'
import {
  BFormGroup, BFormInput,
} from 'bootstrap-vue'
import { required } from '@validations'

export default {
  name: 'ReceiptNo',
  components: {
    BFormGroup,
    BFormInput,
    ValidationProvider,
  },
  data() {
    return {
      required,
    }
  },
  computed: {
    dataItem() {
      return this.$store.getters['accountActivities/dataItem']
    },
  },
  created() {
    localize('tr')
  },
}
</script>
